<template>
    <div class="ellipsis-box">
        <div :class="{'over-step': is_ellipsis}" ref="overStep"  v-html="content" style="text-align: center;width: 100%;">{{content}}</div>
        <el-popover trigger="click" placement="top" class="td-popover" width="300" v-if="is_ellipsis">
            <p class="inside-text" ref="insideText" v-html="content">{{content}}</p>
            <i slot="reference" class="el-icon-arrow-down"></i>
        </el-popover>
    </div>
</template>
<script>
    export default({
        props:[
            'content',
        ],
        data () {
            return {
                is_ellipsis: false,
            }
        },
        methods: {
        isPopover(){
            if(this.$refs.overStep.offsetHeight > 23){
                this.is_ellipsis = true;
            }else{
                this.is_ellipsis = false;
            }
        }
    },
    mounted: function () {
        this.$nextTick( () => {
            this.isPopover();
        })
    }
    })
</script>

